import { z } from "zod";

export const ProjetoRevisaoResumoSchema = z.object({
  idProjetoRevisaoResumo: z.number().optional(), 
  idProjeto: z.number().nullable().optional(),
  idDisciplina: z.number().nullable().optional(),
  descricao: z.string().nullable().optional(),
  responsavel: z.string().nullable().optional(),
  idFuncionario: z.number().nullable().optional(),
  data: z.coerce.date().nullable().optional(),
});

export type ProjetoRevisaoResumoForm = z.infer<typeof ProjetoRevisaoResumoSchema>;
